import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Circle, LatLng, Map, Marker, Polygon, Polyline, Rectangle } from 'leaflet';
import { startWith } from 'rxjs/operators';

import { ZonarUiMapModule } from '@zonar-ui/zonar-ui-map';

import { ReloadMapService } from '@src/app/services/reload-map-service/reload-map.service';
import { SelectedCompanyService } from '@src/app/services/selected-company-service/selected-company.service';
import { MapService } from '@src/app/services/map-service/map.service';

@Component({
  selector: 'app-map-wrapper',
  standalone: true,
  imports: [CommonModule, ZonarUiMapModule],
  templateUrl: './map-wrapper.component.html',
  styleUrls: ['./map-wrapper.component.scss']
})
export class MapWrapperComponent {
  isShowToolbar = true;
  companyId$ = this.companyService.getCurrentCompany();
  reload$ = this.reloadMapService.getReload().pipe(startWith(true));

  constructor(
    private companyService: SelectedCompanyService,
    private reloadMapService: ReloadMapService,
    private mapService: MapService
  ) {}
  map: Map;

  handleData(e) {
    // Get the layer from the event object
    const layer = e.layer
    if (layer instanceof Polygon) {
      // For polygons, get the array of latLngs
      const latLngs = layer.getLatLngs();
      this.mapService.updateLatLngsPolygon(latLngs);
    }
  }
}
